
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/module-sequence-footer/jst/ModuleSequenceFooter';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "\n        <span class=\"module-sequence-footer-button--previous\"></span>\n      ";
  }

function program3(depth0,data) {
  
  
  return "\n        <span class=\"module-sequence-footer-button--next\"></span>\n      ";
  }

  buffer += "<div class='module-sequence-padding'></div>\n<div class='module-sequence-footer' role=\"navigation\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("jquery.module_sequence_footer")
  },data:data},helper ? helper.call(depth0, "module_navigation_97043417", "Module Navigation", options) : helperMissing.call(depth0, "t", "module_navigation_97043417", "Module Navigation", options)))
    + "\">\n  <div class=\"module-sequence-footer-content\">\n    <div class=\"module-sequence-footer-left\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.previous)),stack1 == null || stack1 === false ? stack1 : stack1.show), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"module-sequence-footer-right\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.next)),stack1 == null || stack1 === false ? stack1 : stack1.show), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  